module.exports = "\n\n<div class=\"container main-container\">\n\n  <!-- <app-template></app-template> -->\n\n  <app-data></app-data>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/angular/14angularFormData Detectar cambios en valores/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main